<template>
    <section class="testimonial-area different-bg" v-if="testimonialData.length">
        <div class="container">
            <!-- Testimonial Slider Area Start -->
            <div class="row testimonial-slider-wrapper">
                
                <div class="col-12">
                    <div class="section-title-area">
                        <h2 class="section-heading">{{ pageData.page_heading }} <span class="d-block"></span></h2>
                        <p v-if="pageData.subheading" class="section-subheading">{{ pageData.subheading }}</p>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-12">
                    <div class="testimonial-slider">
                        <splide :options="options" :slides="testimonialData">
                         
                            <splide-slide class="item" v-for="(item, indx) of testimonialData" :key="indx">
                                <div class="testimonial-slide-box">
                                    <img v-if="item.image_name" :src="filePath+'/thumb/'+item.image_name" :alt="item.heading">
                                    <h5>{{ item.heading }}</h5>
                                    <div v-html="item.content"></div>
                                </div>
                            </splide-slide>
                           
                        </splide>
                    </div>

                    <!-- Next/Preview Button Start-->
                    <!-- <div class="testimonial_slide_nav" >
                        <span class="testi_prev" @click="prevSlide">
                            <i class="flaticon-left-arrow"></i>
                        </span>
                        <span class="testi_next" @click="nextSlide">
                            <i class="flaticon-right-arrow"></i>
                        </span>
                    </div> -->
                    <!-- Next/Preview Button End-->
                </div>

            </div>
            <!-- Testimonial Slider Area End -->
        </div>
    </section>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
export default {
    components: { 
        Splide,
        SplideSlide
    },
    data() {
        return {
            options: {
                direction: 'ttb',
                height   : '20rem',
                arrows   : true,
                // classes: {
                //     arrows: 'splide__arrows your-class-arrows',
                //     arrow : 'splide__arrow your-class-arrow',
                //     prev  : 'splide__arrow--prev your-class-prev',
                //     next  : 'splide__arrow--next flaticon-right-arrow',
                // },
            },
            testimonialData: [],
            filePath: '',
            limit: 999,
            pageData: []
        }
    },
    methods: {
        nextSlide(){
            document.querySelector('.splide__arrow--next').click()
        },
        prevSlide(){
            document.querySelector('.splide__arrow--prev').click()
        },
        getData(){
            let params = {
                limit: this.limit
            }
            this.$http.get(`/testimonial`, { params }).then(res=>{ 
                if(res.status === 200 && res.data.result){
                    this.testimonialData = res.data.result
                    this.filePath = res.data.file_path
                    this.pageData = res.data.page_data
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>